import React from 'react';
import Context, { apis } from './Context';

function Provider({ children }) {
  return <Context.Provider value={apis}>{children}</Context.Provider>;
}

export default Provider;
